<template>
  <div class="main-box main-min-height">
    <div class="table-box bgffffff">
      <div>
        <el-form :model="searchForm" size="mini" label-width="80px" ref="searchForm">
          <el-row :gutter="22">
            <el-col :span="5">
              <el-form-item prop="date" label="下单时间">
                <DateTime v-model="searchForm.date" format='yyyy-MM-dd' style="width:100%;height:27px" type='daterange' placeholder="-请选择-" />
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label-width="20px">
                <el-button type="primary" @click="getInfo(true)">
                  查询
                </el-button>
                <el-button type="primary" @click="go(1)">
                  添加
                </el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <el-table :data="tableData" stripe border style="width: 100%">
        <el-table-column prop="id" label="id" width="80">
        </el-table-column>
        <el-table-column prop="title" label="标题" width="280">
        </el-table-column>
        <el-table-column prop="simpleLanguage" label="描述">
        </el-table-column>
        <el-table-column label="操作" width="150">
          <template slot-scope="{row}">
            <el-button type="primary" size="mini" @click="go(2,row.id)">编辑</el-button>
            <el-button type="danger" size="mini" @click="del(row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <Pagination location='left' :page='page' @getData="getInfo" />
    </div>
  </div>
</template>

<script>
import Pagination from '@/components/pagination/Pagination.vue'
import DateTime from '@/components/DateTime'
export default {
  name: 'News',
  components: {
    DateTime,
    Pagination,
  },
  data() {
    return {
      searchForm: {
        date: null,
        beginTime: null, //下单开始时间
        endTime: null, //下单结束时间
      },//查询条件
      page: { //翻页处理
        currentPage: 1,
        pageSize: 50,
        total: 0,
      },
      tableData: [],//表格参数
      BusinessList:[],//商户列表
      dialogEditVisible: false,
      ruleForm: {
        id:null,
        merchantId:null, //商户id
        details:null, //是否显示(1显示2隐藏)默认显示
        title:null, //	标题(别超过25个中文字符)
        sort:null, //	顺序(值越小排名越靠前,不能小于1)
        picture:null, //主图
        simpleLanguage:null, //简语
      },
      rules: {},
      title: '新增商户',
    };
  },
  computed: {},
  watch: {
    'searchForm.date': {
      handler(val) {
        this.searchForm.beginTime = val[0]
        this.searchForm.endTime = val[1]
      },
      deep: true
    }
  },
  mounted() {
    this.getInfo();
    this.getBusiness()
  },
  methods: {
    //获取查询信息
    getInfo(bool) {
      bool ? this.page.currentPage = 1 : ''
      this.$News.pageList(
        {
          ...this.searchForm,
          page: this.page.currentPage,
          limit: this.page.pageSize
        }
      ).then(({ data }) => {
        if (data.code === 200) {
          this.tableData = data.data
          this.page.total = data.count
        }
      })
    },
    del(id) {
      this.$News.del({ids:id}).then(({ data }) => {
        if (data.code === 200) {
          this.messages(data.message, true, 1000)
          this.getInfo()
        }
      })
    },
     //获取商户列表
    getBusiness() {
      this.$MerchantManagement.total().then(({ data }) => {
        if (data.code === 200) {
          this.BusinessList = data.result
        }
      })
    },
    go(type,id){
      this.$router.push({path:'/management/StoreSettings/NewsAddItem',query:{type,id}})
    }
  }
};
</script>

<style lang="scss" scoped>
.y_color {
  color: #ff702e;
}
.lv_color {
  color: #0acd5e;
}
</style>
